/**
 * Custom JavaScript - Ferma cu Omenie
 */

// ================================================
// 1. PRODUCT GRID AJAX ADD TO CART
// ================================================
(function() {
  'use strict';

  function initProductGridForms() {
    var gridForms = document.querySelectorAll('.product-form--grid');
    gridForms.forEach(function(form) {
      if (form.dataset.ajaxInitialized === 'true') return;
      if (typeof theme === 'undefined' || !theme.AjaxProduct) return;
      try {
        new theme.AjaxProduct(form);
        form.dataset.ajaxInitialized = 'true';
      } catch (error) {
        console.error('Error initializing AJAX form:', error);
      }
    });
  }

  document.addEventListener('page:loaded', initProductGridForms);
  document.addEventListener('DOMContentLoaded', initProductGridForms);
  document.addEventListener('collection:reloaded', initProductGridForms);
})();

// ================================================
// 2. STICKY ADD TO CART BUTTON — mobile
// ================================================
(function() {
  'use strict';

  function initStickyBtn() {
    // Rulează doar pe pagina de produs
    if (!document.querySelector('.product-single__form')) return;

    // Evită dubla inițializare
    if (document.querySelector('.sticky-atc-round')) return;

    var originalBtn = document.querySelector('[data-add-to-cart]');
    if (!originalBtn) return;

    var btn = document.createElement('button');
    btn.className = 'sticky-atc-round';
    btn.setAttribute('type', 'button');
    btn.setAttribute('aria-label', 'Adaugă în coș');
    // Luăm denumirea produsului din pagină
    var productTitle = document.querySelector('.product-single__title');
    var titleText = productTitle ? productTitle.textContent.trim() : '';
    // Trunchierea titlului dacă e prea lung
    var shortTitle = titleText.length > 20 ? titleText.substring(0, 18) + '…' : titleText;
    var btnLabel = shortTitle ? 'Adaugă ' + shortTitle + ' în coș' : 'Adaugă în coș';

    btn.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><span>' + btnLabel + '</span>';
    document.body.appendChild(btn);

    btn.addEventListener('click', function() {
      if (!originalBtn.disabled) originalBtn.click();
    });

    window.addEventListener('scroll', function() {
      var rect = originalBtn.getBoundingClientRect();
      btn.classList.toggle('is-visible', rect.bottom < 0);
    }, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', initStickyBtn);
  document.addEventListener('page:loaded', initStickyBtn);
})();